const PENDING_SAVE_AFTER_LOGIN_KEY = 'imsFloorplanner.pendingSaveAfterLogin';

export const markPendingSaveAfterLogin = (): void => {
  try {
    window.sessionStorage.setItem(PENDING_SAVE_AFTER_LOGIN_KEY, 'true');
  } catch {
    // Ignore storage errors; the in-memory login callback still handles non-redirect logins.
  }
};

export const hasPendingSaveAfterLogin = (): boolean => {
  try {
    return window.sessionStorage.getItem(PENDING_SAVE_AFTER_LOGIN_KEY) === 'true';
  } catch {
    return false;
  }
};

export const clearPendingSaveAfterLogin = (): void => {
  try {
    window.sessionStorage.removeItem(PENDING_SAVE_AFTER_LOGIN_KEY);
  } catch {
    // Nothing to clean up if sessionStorage is unavailable.
  }
};
